<div class="container" style="display: flex; flex-direction:column; justify-content: space-between; height:100%">
  <form [formGroup]="mappingForm">
    <div class="row" style="align-items: center;">
      <div class="col-10">
        <h3 i18n class="display-6"
          align="center"
          style="padding-top: 10px; color: #005d87; font-weight: bold;">
                    Add/Edit Mapping
                </h3>
      </div>

      <div class="col-2">
        @if (!data.isNew) {
          <button mat-mini-fab matTooltip="Delete mapping" style="background-color: coral; color: white" (click)="deleteRecord()">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>

    </div>



    @if (data.type == 'fin-vrn') {
      <div class="row">
        <h6 i18n class="small-header">
            Fisher Identification Number
            </h6>
        <mat-form-field appearance="fill">
          <mat-label i18n>
                FIN
            </mat-label>
          <input matInput
            required
            maxlength="16"
            formControlName="fin">
            @if (mappingForm.get('fin')?.errors?.required) {
              <mat-error i18n>
                    Required
                </mat-error>
            }
          </mat-form-field>
        </div>
      }

      <div class="row" style="margin-top: 25px;">

        <h6 i18n class="small-header">
            Vessel Registration Number
            </h6>
        <mat-form-field appearance="fill">
          <mat-label i18n>
                    VRN
                </mat-label>
          <input matInput
            required
            maxlength="16"
            formControlName="vesselNumber">
            @if (mappingForm.get('vesselNumber')?.errors?.required) {
              <mat-error i18n>
                    Required
                </mat-error>
            }
            @if (mappingForm.get('vesselNumber')?.errors?.duplicate) {
              <mat-error i18n>
                    Mapping for this VRN already exists
                </mat-error>
            }
          </mat-form-field>

        </div>

        @if (data.type == 'vrn-lb') {
          <div class="row">
            <h6 i18n class="small-header">
                Logbook Number(s)
            </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>
                Logbooks
                </mat-label>
              <mat-select formControlName="logbookIndexes"
                multiple>
                @for (number of data.logbooks; track number; let i = $index) {
                  <mat-option
                    [value]="i">
                    {{number.logbookID}}
                  </mat-option>
                }
              </mat-select>
              @if (mappingForm.get('logbookIndexes')?.errors?.required) {
                <mat-error i18n>
                    Required
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </form>

      <!-- Back and Add buttons -->
      <div class="row bottom-buttons">

        <div class="outer">

          <div class="inner" style="margin-right: 50%">
            <button i18n mat-stroked-button
              type="button"
              style="background-color: #005d87; color: white; font-weight: bold;"
              (click)="dialogRef.close()">
                Back
            </button>    
          </div>

          <div class="inner">
            <button i18n mat-stroked-button
              align="end"
              type="submit"
              style="background-color: #ff6f61; color: white; font-weight: bold;"
              (click)="returnResult()">
                Add
            </button>                
          </div>

        </div>

      </div>

    </div>